module.exports = __webpack_public_path__ + "img/star8-10.71287656.svg";